import { m as merge, z as getComponentFromVNode, A as copyAppContext, _ as _defineProperty } from './helpers-8130329a.js';
import { _ as _createClass, a as _classCallCheck } from './classCallCheck-119e2995.js';
import { createApp, h } from 'vue';
import { s as script } from './Modal-df95de0a.js';
export { s as BModal } from './Modal-df95de0a.js';
import { u as use, a as registerComponent, r as registerComponentProgrammatic } from './plugins-9a909142.js';
import './typeof-92b42de1.js';
import './trapFocus-3002f535.js';
import './config-86592f14.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ModalProgrammatic = /*#__PURE__*/function () {
  function ModalProgrammatic(app) {
    _classCallCheck(this, ModalProgrammatic);
    this.app = app; // may be undefined in the testing environment
  }
  _createClass(ModalProgrammatic, [{
    key: "open",
    value: function open(params) {
      if (typeof params === 'string') {
        params = {
          content: params
        };
      }
      var defaultParam = {
        programmatic: true
      };
      if (params.parent) {
        delete params.parent;
      }
      var slot;
      if (Array.isArray(params.content)) {
        slot = params.content;
        delete params.content;
      }
      var propsData = merge(defaultParam, params);
      var container = document.createElement('div');
      // Vue 3 requires a new app to mount another component
      var vueInstance = createApp({
        data: function data() {
          return {
            modalVNode: null
          };
        },
        methods: {
          close: function close() {
            var modal = getComponentFromVNode(this.modalVNode);
            if (modal) {
              modal.close();
            }
          }
        },
        render: function render() {
          this.modalVNode = h(script, _objectSpread(_objectSpread({}, propsData), {}, {
            onClose: function onClose() {
              vueInstance.unmount();
            },
            // intentionally overrides propsData.onCancel
            // to prevent propsData.onCancel from receiving a "cancel" event
            onCancel: function onCancel() {},
            cancelCallback: function cancelCallback() {
              if (propsData.onCancel != null) {
                propsData.onCancel.apply(propsData, arguments);
              }
            }
          }), slot ? {
            default: function _default() {
              return slot;
            }
          } : undefined);
          return this.modalVNode;
        }
      });
      if (this.app) {
        copyAppContext(this.app, vueInstance);
      }
      return vueInstance.mount(container);
    }
  }]);
  return ModalProgrammatic;
}();
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
    registerComponentProgrammatic(Vue, 'modal', new ModalProgrammatic(Vue));
  }
};
use(Plugin);

export { ModalProgrammatic, Plugin as default };
